import "./assign-shops-confirm-modal.scss";
import { observer } from "mobx-react";
import { DefaultModalLayout } from "../../../../components/modal/layouts/default-modal-layout";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import PlanInfoAdmin from "./plan-info/plan-info-admin";
import AssignShopsToPlanStore from "../../stores/assign-shops-to-plan-store";
import Loader from "./processing-indicator/processing-indicator";
import ShopsSelector from "../../../../components/shops-selector/shops-selector";
import { IShop } from "../../../../models/User";
import { Note, NOTE_TYPE } from "../../../../components/note/note";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import { useCallback } from "react";

interface AssignShopsConfirmModalProps {
    store: AssignShopsToPlanStore;
    onClose: () => void;
}

const AssignShopsConfirmModal: React.FC<AssignShopsConfirmModalProps> = observer(({ store, onClose }) => {
    const getShopTag = useCallback((shop: IShop) => {
        const tag = shop.plan_id === store.plan.id
            ? 'assigned' : shop.move_to_plan === store.plan.id
                ? 'moved to' : '';
        return {
            tag,
            isSelectable: !tag
        }
    }, [store.plan.id]);


    const childStoreNote = (parentName: string | undefined, childStoreName: string) =>
         <div>
            {` A ${childStoreName} store is currently connected to ${parentName}’s plan. 
            Assigning a new plan for this store will remove it from ${parentName}’s parent plan.`}
         </div>


    const note = () => <>
            <div>
                Once you assign to a new plan, the merchants will get a link
                that will redirect them to approve the new billing.
                Until then, the stores will not be assigned to this plan.
            </div>
            {
                store.selectedShops.filter(shop => shop.isChild).map(shop => childStoreNote(shop.parentName, shop.name))
            }
        </>

    return (
        <DefaultModalLayout
            isCloseDisabled={false}
            onCloseClicked={onClose}
            buttons={[
                {
                    text: 'Cancel',
                    disabled: store.isProcessing,
                    onClick: onClose,
                    variant: BUTTON_VARIANTS.Tertiary
                },
                {
                    text: 'Assign',
                    disabled: !store.selectedShops.length || store.isProcessing,
                    onClick: store.assignPlanToShops,
                    variant: BUTTON_VARIANTS.Primary
                }
            ]}
        >
            <div className="assign-shops-modal-content">
                <Loader isProcessing={store.isProcessing} />
                <div className="modal-title">
                    <FontBody1 color={FONT_COLOR.NEUTRAL3}>Assign stores</FontBody1>
                </div>
                <PlanInfoAdmin
                    plan={store.plan.getUpdatedModel()}
                    featuresInfo={store.featuresInfo}
                />
                <FontBody2 variant={FONT_VARIANT.BOLD}>Assign stores</FontBody2>
                <ShopsSelector
                    onChange={store.setSelectedShops}
                    getShopTag={getShopTag}
                />
                <Note
                    type={NOTE_TYPE.INFORMATION}
                    body={note()}
                />
            </div>
        </DefaultModalLayout>
    );
});

export default AssignShopsConfirmModal;
